import { useNavigate } from "react-router-dom"
import { SquaredTickIcon } from "../../ui/icons/SquaredTickIcon"
import { formatterDate, optionsFormatter, ProdIntegrataNotScopo, ProdIntegrataNotType } from "../../utils"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { GGNotificationDTO } from "./globalGap/dataservice/dto"
import { useEffect, useState } from "react"
import Button from "../../ui/molecules/button"
import { PlusIcon } from "../../ui/icons/plus"
import { NotifyAddProdIntegrata } from "./prodIntegrata/add"
import { PopupForm } from "../../ui/organisms/popupForm"
import { GetNotSQNPI, resetCreateStatus, resetGetAllStatus, setNotificationIdToUpdate, setNotSqnpiUpdateRequest } from "./prodIntegrata/dataService/slice"
import { NotSQNPIDTO, NotSQNPIDTOResponse, UpdateNotSQNPIDTO } from "./prodIntegrata/dataService/dto"

export function NotifyProdIntegrataList() {
    const dispatch = useAppDispatch()
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const navigate = useNavigate()
    const notificationSQNPIState = useAppSelector(state => state.NotificationSQNPI)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetNotSQNPI(notificationSQNPIState.getAllNotificationFilters))
    }, [])

    useEffect(() => {
        if (notificationSQNPIState.createNotSQNPIStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetCreateStatus())
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [notificationSQNPIState.createNotSQNPIStatus])

    useEffect(() => {
        if (notificationSQNPIState.getAllNotificationStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    })

    const onEditHandle = (n: NotSQNPIDTO) => {
        dispatch(setNotificationIdToUpdate(n.id))
        dispatch(setNotSqnpiUpdateRequest({
            adhesionTypes: n.adhesionTypes,
            adhesionDate: n.adhesionDate,
            campaignYear: n.campaignYear,
            type: n.type,
            number: n.number,
            regionalMark: n.regionalMark ? true : false,
            protocolDate: n.protocolDate,
            sqnpiNotificationConfirmationId: n.sqnpiNotificationConfirmationId !== null ? n.sqnpiNotificationConfirmationId : undefined,
            sqnpiNotificationRectificationId: n.sqnpiNotificationRectificationId !== null ? n.sqnpiNotificationRectificationId : undefined,
            protocol: n.protocol !== null ? n.protocol : undefined,
            region: n.region,
            note: n.note,
            purpose: n.purpose
        }))
        navigate('/notifySqnpiEdit')
    }

    return (
        <div style={{ padding: '24px' }}>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">Anno</th>
                        <th className="width-[130px]">Regione</th>
                        <th className="width-[100px]">Numero</th>
                        <th className="width-[130px]">Protocollo</th>
                        <th className="width-[20%]">Data Protocollo</th>
                        <th className="width-[130px]">Data Adesione</th>
                        <th className="width-[130px]">Scopo</th>
                        <th className="width-[130px]">Marchio Regionale</th>
                        <th className="width-[130px]">Tipologia Adesione</th>
                        <th className="width-[130px]">Conferma Domanda</th>
                        <th className="width-[130px]">Rettifica Domanda</th>
                        <th className="width-[130px]">Note</th>
                        <th className="width-[130px]" style={{ borderTopRightRadius: '8px', width: '40px' }}>Particelle</th>
                    </tr>
                </thead>
                <tbody>
                    {notificationSQNPIState.getAllNotificationResponse?.data.map((row, index) =>
                        <tr
                            key={index}
                            style={{
                                color: '#4D797F',
                                background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                            }}
                        >
                            <td>
                                <div style={{ display: 'flex', gap: '6px' }}>
                                    <button onClick={() => onEditHandle(row)}>
                                        <SquaredTickIcon />
                                    </button>
                                </div>
                            </td>
                            <td>{row.campaignYear}</td>
                            <td>{row.region}</td>
                            <td>{row.number}</td>
                            <td>{row.protocol}</td>
                            <td>{formatterDate(row.protocolDate!)}</td>
                            <td>{formatterDate(row.adhesionDate!)}</td>
                            <td>{optionsFormatter(row.purpose, ProdIntegrataNotScopo)}</td>
                            <td>{
                                row.regionalMark ? (
                                    <span>SI</span>
                                ) : (<span>No</span>)
                            }
                            </td>
                            <td>
                                {
                                    row.adhesionTypes?.map((type) =>
                                        <div>
                                            <span>{type}</span>
                                        </div>
                                    )
                                }
                            </td>
                            <td>{row.sqnpiNotificationConfirmationId}</td>
                            <td>{row.sqnpiNotificationRectificationId}</td>
                            <td>{row.note}</td>
                            <td></td>
                        </tr>
                    )}


                </tbody>
            </table>
            <div className="mt-10">
                <Button
                    color="orange"
                    variant="solid"
                    iconPosition="left"
                    icon={<PlusIcon color="#fff" size={24} />}
                    size="md"
                    label="Inserisci Notifica"
                    onClick={() => { setShowAddPopup(true) }}
                />
            </div>
            {
                showAddPopup &&
                <PopupForm title={`Aggiungi domanda`} headerGreen close={() => setShowAddPopup(false)}>
                    <NotifyAddProdIntegrata close={() => setShowAddPopup(false)}></NotifyAddProdIntegrata>
                </PopupForm>
            }
        </div>
    )
}